import { Language, languages } from '~/types/api/users'

export function getLanguage(host?: string | null): Language | null {
  if (!host) return null

  const subdomain = host.split('.')[0]

  return languages.includes(subdomain as Language) ? (subdomain as Language) : null
}
